function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#DEE4EE"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.712.508H9.534c-.732 0-1.35.619-1.35 1.35v1.94c0 .338.28.62.618.62.338 0 .647-.282.647-.62V1.83c0-.057.028-.085.085-.085h3.178a1.2 1.2 0 011.21 1.21V15.02a1.2 1.2 0 01-1.21 1.21H9.534c-.057 0-.085-.028-.085-.085v-1.94a.63.63 0 00-.647-.62.607.607 0 00-.618.62v1.94c0 .732.618 1.35 1.35 1.35h3.178a2.479 2.479 0 002.475-2.475V2.983A2.479 2.479 0 0012.712.508z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.434 8.55L7.62 5.683a.628.628 0 00-.9 0 .628.628 0 000 .9l1.744 1.772H3.459a.624.624 0 00-.62.619c0 .337.282.618.62.618h5.034l-1.772 1.8a.628.628 0 000 .9.639.639 0 00.45.17.56.56 0 00.45-.198l2.813-2.868c.253-.197.253-.591 0-.844z"
})));